import {LoggerServiceNamespace} from "./logger-service-namespace";

/**
 *
 */
export class LoggerServiceNamespaceRegistry {
  private static namespaces: Record<string, LoggerServiceNamespace> = {};

  public static get(namespace: string): LoggerServiceNamespace {
    // make sure we have a logger for namespace
    LoggerServiceNamespaceRegistry.namespaces[namespace] ??= new LoggerServiceNamespace(namespace);
    // return logger for namespace
    return LoggerServiceNamespaceRegistry.namespaces[namespace];
  }

}
